import React from 'react'
import { F0TagDot } from '@factorialco/f0-react'
import { getTicketStatusLabel, getTicketStatusVariant } from 'modules/ticketing/lib/ticketStatus'
interface TicketStatusProps {
  status: string
}

export const TicketStatus: React.FC<TicketStatusProps> = ({ status }) => {
  return <F0TagDot text={getTicketStatusLabel(status)} color={getTicketStatusVariant(status)} />
}

export default TicketStatus
